export default __webpack_public_path__ + "static/media/icon2.f6c4826b.svg";